import { FeedbackMetadataField } from '@modules/feedback/types';

interface GetFeedbackSourceMetadataGroupedByObjectIDParams {
  metadataFields: FeedbackMetadataField[];
}

export const getFeedbackSourceMetadataGroupedByObjectID = ({
  metadataFields,
}: GetFeedbackSourceMetadataGroupedByObjectIDParams) => {
  const groupedByObjectID: Record<string, FeedbackMetadataField[]> = {};

  metadataFields.forEach((metadataField) => {
    if (!groupedByObjectID[metadataField.objectID]) {
      groupedByObjectID[metadataField.objectID] = [];
    }
    groupedByObjectID[metadataField.objectID].push(metadataField);
  });

  return groupedByObjectID;
};
